import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagIM = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m34.257 16.759-1.767 6.306-5.302-.98-3.413-7.034-9.22 3.272-.726-2.05-2.413-.296 1.818 5.122 6.345-1.623 1.803 5.08-4.386 6.474 7.443 6.348-1.411 1.654.949 2.238 3.527-4.135-4.578-4.684 3.499-4.102 7.799.562L36 19.291l2.138.395 1.464-1.94-5.345-.987Z"
}));
FlagIM.displayName = 'FlagIM';
export default withFlagWrapper(FlagIM);
//# sourceMappingURL=index.js.map